import { Button, Checkbox, Group, Loader, Stack, Text } from '@mantine/core';
import { useState } from 'react';

import { CustomsError } from '@e-origin/shared';

import { TextInput } from '@components';
import { useEditCustomsErrorFormInitializer } from './useEditCustomErrorFormInitializer';

interface EditCustomsErrorProps {
  customsError?: CustomsError;
  onHide: () => void;
}

export const EditCustomsError: React.FC<EditCustomsErrorProps> = ({ customsError, onHide }) => {
  const [formError, setFormError] = useState<string | null>(null);

  const { form, onSubmit, isSubmitting } = useEditCustomsErrorFormInitializer({
    customsError,
  });

  const handleSubmit = async (values) => {
    setFormError(null);

    try {
      await onSubmit(values);
      onHide();
    } catch (error: any) {
      setFormError(error?.response?.data?.message || 'Failed to save customs error');
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap="md" my="xl">
        <TextInput {...form.getInputProps('errorMessage')} label="Error Message" placeholder="Enter error message" />
        <TextInput {...form.getInputProps('errorReason')} label="Error Reason" placeholder="Enter error reason" />
        <TextInput {...form.getInputProps('declarationAttributePointer')} label="Declaration Attribute Pointer" placeholder="Enter attribute pointer" />
        <Checkbox
          {...form.getInputProps('runCustomsSyncByLRN', { type: 'checkbox' })}
          label="Run Customs Sync By LRN"
          checked={form.values.runCustomsSyncByLRN}
          onChange={(event) => form.setFieldValue('runCustomsSyncByLRN', event.currentTarget.checked)}
        />
      </Stack>

      {formError && (
        <Text c="red" fw="bold" mt="md">
          {formError}
        </Text>
      )}

      <Group justify="center" mt="xl">
        <Button type="button" key="cancel-modal-btn" onClick={() => onHide()} disabled={isSubmitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button
          key="save-modal-btn"
          disabled={!form.isValid() || isSubmitting}
          type="submit"
          leftSection={isSubmitting && <Loader color="white" />}
          variant="filled"
          size="lg"
        >
          Save
        </Button>
      </Group>
    </form>
  );
};
